import React from "react";
import { makeStyles, Step, Stepper as MaterialStepper, StepLabel, StepConnector } from "@material-ui/core";
import { useRouter } from "next/router";
import classnames from "classnames";
export default function Stepper({ steps, stepsNames, activeStep }) {
  const classes = useStyle();
  const router = useRouter();
  const step = activeStep || steps.findIndex((el) => el === router.query?.step) + 1;

  return (
    <div className={classes.container}>
      <MaterialStepper alternativeLabel activeStep={step} connector={<StepConnector />}>
        {stepsNames.map((label, index) => (
          <Step key={label}>
            <StepLabel
              StepIconComponent={() => (
                <div className={classnames({ [classes.activeBullet]: step - 1 === index }, classes.bullet)} />
              )}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </MaterialStepper>
    </div>
  );
}

const useStyle = makeStyles((theme) => ({
  bullet: {
    width: 10,
    height: 10,
    borderRadius: 50,
    zIndex: 2,
    backgroundColor: "white",
    [theme.breakpoints.down("sm")]: {
      position: "absolute",
      bottom: "-3px",
      marginLeft: "auto",
      marginRight: "auto",
      right: "0",
      left: "0",
      backgroundColor: "transparent",
    },
  },
  activeBullet: {
    [theme.breakpoints.down("sm")]: {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  container: {
    overflow: "visible",
    [theme.breakpoints.down("sm")]: {
      overflow: "clip",
      "& .MuiPaper-root": {
        paddingLeft: 0,
        width: "100%",
        paddingRight: 0,
        paddingBottom: 0,
      },
      "& .MuiStep-root.MuiStep-completed:first-child:before": {
        display: "block",
        height: 3,
        width: "40%",
        backgroundColor: theme.palette.secondary.main,
        content: "''",
        position: "absolute",
        bottom: 0,
        left: "10%",
      },
      "& .MuiStep-root": {
        "&:not(.MuiStep-completed)": {
          "& .MuiStepConnector-lineHorizontal": {
            borderColor: "transparent !important",
          },
        },
        "& .MuiStepConnector-lineHorizontal": {
          bottom: "-4px",
          position: "absolute",
        },
        "& .MuiStepConnector-alternativeLabel": {
          left: "calc(-70%)",
          right: "calc(50%)",
        },
      },
    },

    "& .MuiPaper-root": {
      backgroundColor: "transparent",
      [theme.breakpoints.up("md")]: {
        width: "min(80vw , 700px)",
        paddingLeft: 0,
        marginLeft: -70,
      },
      "@media(max-width: 1400px)": {
        marginLeft: theme.spacing(3),
      },
      [theme.breakpoints.down("sm")]: {
        marginLeft: 0,
      },
      "& .MuiStep-root": {
        "& .MuiStepLabel-root": {
          flexDirection: "column-reverse",
          "& .MuiStepLabel-label.MuiStepLabel-alternativeLabel": {
            marginTop: 0,
            whiteSpace: "nowrap",
            marginBottom: theme.spacing(2),
            fontWeight: "bold",
            color: theme.palette.secondary.main,
            fontSize: 13,
            [theme.breakpoints.down("sm")]: {
              fontSize: 12,
            },
          },
        },
        "& .MuiStepConnector-alternativeLabel": {
          [theme.breakpoints.up("md")]: {
            left: "calc(-50%)",
            right: "calc(50%)",
          },
          bottom: 4,
          display: "flex",
          alignItems: "flex-end",
          "& .MuiStepConnector-lineHorizontal": {
            borderTopWidth: 3,
            borderColor: "white",
            width: "100%",
          },
        },
      },
      "& .MuiStep-completed.MuiStep-root": {
        "& .MuiStepLabel-root": {
          "& .MuiStepLabel-label.MuiStepLabel-alternativeLabel": {
            color: theme.palette.secondary.main,
          },
        },
        "& .MuiStepLabel-alternativeLabel": {
          "& > div": {
            [theme.breakpoints.up("md")]: {
              backgroundColor: theme.palette.secondary.main,
            },
          },
        },
        "& .MuiStepConnector-alternativeLabel": {
          "& .MuiStepConnector-lineHorizontal": {
            borderColor: theme.palette.secondary.main,
          },
        },
      },
    },
  },
}));
